import {PRODUCT_CONSTS, AUTH_CONSTS} from "../constants";

export const initialState = {
    products: {
        itemsList: [],
        hasMore: false,
        text: '',
        filterValueId: undefined,
        categoryId: undefined,
        minPrice: '',
        maxPrice: '',
        filtered: false,
    },
    productById: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case PRODUCT_CONSTS.GET_PRODUCTS:
            return {
                ...state,
                products: {
                    itemsList: action.payload.reset ? action.payload.data : [...state.products.itemsList, ...action.payload.data],
                    text: action.payload.text,
                    categoryId: action.payload.categoryId,
                    filterValueId: action.payload.filterValueId,
                    minPrice: action.payload.minPrice,
                    maxPrice: action.payload.maxPrice,
                    filtered: action.payload.filtered,
                    hasMore: action.payload.hasMore
                }
            };
        case PRODUCT_CONSTS.GET_PRODUCT_BY_ID:
            return {
                ...state,
                productById: action.payload
            };
        case PRODUCT_CONSTS.ADD_PRODUCT:
            return {
                ...state,
                products: {
                    ...state.products,
                    itemsList: [action.payload, ...state.products.itemsList],
                    count: state.products.count + 1
                }
            };
        case PRODUCT_CONSTS.UPDATE_PRODUCT:
            return {
                ...state,
                products: {
                    ...state.products,
                    itemsList: state?.products?.itemsList?.map(product => product.id === action.payload.id ?
                        action.payload : product)
                }
            };
        case PRODUCT_CONSTS.TOGGLE_PRODUCT_VISIBILITY:
            return {
                ...state,
                products: {
                    ...state.products,
                    itemsList: state?.products?.itemsList?.map(product => product.id === action.payload.id ?
                        {
                            ...product,
                            isHidden: action.payload.isHidden
                        } : product)
                }
            };
        case PRODUCT_CONSTS.DELETE_PRODUCT:
            return {
                ...state,
                products: {
                    ...state.products,
                    itemsList: state.products.itemsList.filter(product => product.id !== action.payload),
                    count: state.products.count - 1
                }
            };
        case AUTH_CONSTS.LOG_OUT:
            return initialState;
        default:
            return state;
    }
}
